import {
  THEME__COLOR__ERROR,
  THEME__COLOR__SUCCESS
} from '../../../Layout/Libraries/Theme.lib';
import Icon from '../../../Layout/Wrappers/Icon';
import {
  getMatchEntities
} from '../../Libraries/MatchList.lib';
import {
  MatchPageController
} from '../../MatchPage';
import {
  evaluateChip
} from '../v2/Chip.lib';
import ChipGroup from "./ChipGroup";

const result = (element, toMatchWith) => {
  let result;
  if (element.type === 'chipGroup') {
    result = !!ChipGroup.result(element, toMatchWith) ? { group: 1 } : { group: 0 };
  } else {
    result = evaluateChip({
      have: element,
      candidate: toMatchWith,
      job: getMatchEntities(
        MatchPageController().state
      ).job
    }) ? { group: 1 } : { group: 0 };
  }
  return finalDecision([result]);
}

const finalDecision = (decision) => {
  let text = (
    <Icon mr
      role='ChipNo'
      icon='close'
      color={THEME__COLOR__ERROR}
    />
  );
  decision.forEach(dec => {
    if (dec.group > 0) {
      text = (
        <Icon mr
          role='ChipYes'
          icon='done'
          color={THEME__COLOR__SUCCESS}
        />
      );
    }
  });
  return text;
}

const Chip = {
  result,
}
export default Chip;
